// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__1JNs2","expanded":"Menu_expanded__35oRH","hovered":"Menu_hovered__oHCAi","minized":"Menu_minized__RMH2j"};